import TemplateContents from './TemplateContents';
import { gsap } from 'gsap';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();

    // パラメータ設定
    this.MAX_CURVE = 200;       // 最大カーブ量(px)
    this.MAX_CURVE_SP = 50;     // SP時の最大カーブ量
    this.SCROLL_RANGE = 1000;   // カーブが最大になるスクロール量
    this.BASE_Y = 220;          // カーブの両端のY座標（上から260pxの位置） 4rem(40px)上に移動

    this.CURVE3_TOP_OFFSET_PC = 40;  // curve-svg3の波線の位置(chunk6上端からのオフセット, px, PC)
    this.CURVE3_TOP_OFFSET_SP = 75;  // 同上(SP) デザイン実測: カード上端の約77px下

    this.svg3Top = 0;
    this.svg3HeightPx = 0;

    this.currentCurve = this.MAX_CURVE;
    this.targetCurve = this.MAX_CURVE;

    this.currentCurve2 = 0;
    this.targetCurve2 = 0;

    this.currentCurve3 = 0;
    this.targetCurve3 = 0;

    this.currentCurve4 = 0;
    this.targetCurve4 = 0;

    this.isSp = false;
    this.isAnimatingFlat = false;
    this.flatTween = null;
  }

  setDom() {
    super.setDom();
    this.path1 = document.getElementById('curve-path1');
    this.svg1 = document.getElementById('curve-svg1');
    this.path2 = document.getElementById('curve-path2');
    this.svg2 = document.getElementById('curve-svg2');
    this.section1_5 = document.querySelector('.section1_5');
    this.path3 = document.getElementById('curve-path3');
    this.svg3 = document.getElementById('curve-svg3');
    this.path4 = document.getElementById('curve-path4');
    this.svg4 = document.getElementById('curve-svg4');
    this.section2 = document.querySelector('.section2');
    this.section4 = document.querySelector('.section4');
    this.chunk6 = document.querySelector('.chunk6');
    this.chunk8 = document.querySelector('.chunk8');

    this.updatePath(this.currentCurve, this.path1);
    this.updatePath(0, this.path2);
    this.updatePath(0, this.path3);
    this.updatePath(0, this.path4);

    this.executeResize();
  }

  initEvents() {
    super.initEvents();
  }

  start() {}

  scrollHandler() {
/*    if (this.isAnimatingFlat) {
      this.isAnimatingFlat = false;
      if (this.flatTween) this.flatTween.kill();
      this.flatTween = null;
    }*/

    const windowHeight = window.innerHeight;

    // --- Curve2 のロジックを修正 ---
    if (this.section1_5) {
      const rect = this.section1_5.getBoundingClientRect();
      const elTop = rect.top; // section1_5の上端の、ビューポート上端からの距離

      // アニメーションを開始する位置 (要素の上端が画面の80%の位置に来たとき)
      const animStart = windowHeight * 0.8;
      // アニメーションを完了する位置 (要素の上端が画面の20%の位置に来たとき)
      const animEnd = windowHeight * 0.2;

      // 現在位置がアニメーション区間内のどこにあるかを 0.0 ~ 1.0 で計算
      const rawProgress = (animStart - elTop) / (animStart - animEnd);
      const progress2 = Math.max(0, Math.min(rawProgress, 1));
      this.targetCurve2 = this.easeOutQuart(progress2) * this.MAX_CURVE;
    }

    // --- Curve4 (.section2の手前) ---
    if (this.section2) {
      const rect4 = this.section2.getBoundingClientRect();
      const elTop4 = rect4.top; // section2の上端の、ビューポート上端からの距離

      const animStart4 = windowHeight * 0.8;
      const animEnd4 = windowHeight * 0.2;

      const rawProgress4 = (animStart4 - elTop4) / (animStart4 - animEnd4);
      const progress4 = Math.max(0, Math.min(rawProgress4, 1));
      this.targetCurve4 = this.easeOutQuart(progress4) * this.MAX_CURVE;
    }

    // --- Curve3 (.chunk6の波形背景) ---
    if (this.chunk6) {
      // 画像読み込み等でレイアウトが変わっている可能性があるので配置を再計算
      this.updateCurve3Bounds();

      const rect3 = this.chunk6.getBoundingClientRect();
      // 波線があるchunk6の上端が基準
      const elTop3 = rect3.top;

      const animStart3 = windowHeight * 0.75; // 画面の75%の位置まで上がってきたら開始（画面に入った直後はまだ直線）
      const animEnd3 = windowHeight * 0.2;    // 画面上部20%で完了

      const rawProgress3 = (animStart3 - elTop3) / (animStart3 - animEnd3);
      const progress3 = Math.max(0, Math.min(rawProgress3, 1));
      const maxCurve3 = this.isSp ? this.MAX_CURVE_SP : this.MAX_CURVE;
      this.targetCurve3 = this.easeOutQuart(progress3) * maxCurve3;
    }
  }

  enterframe() {
    // animateToFlat中は、path1の慣性処理を行わない（GSAPに任せる）
    if (!this.isAnimatingFlat) {
      // 慣性処理 (線形補間)
      const diff = this.targetCurve - this.currentCurve;
      
      // 差分が小さければ描画更新しない（パフォーマンス対策）
      if (Math.abs(diff) > 0.05) {
        this.currentCurve += diff * 0.1;
        this.updatePath(this.currentCurve, this.path1);
      }
    }

    // Curve 2
    const diff2 = this.targetCurve2 - this.currentCurve2;
    if (Math.abs(diff2) > 0.05) {
      this.currentCurve2 += diff2 * 0.1;
      this.updatePath(this.currentCurve2, this.path2);
    }

    // Curve 3
    const diff3 = this.targetCurve3 - this.currentCurve3;
    if (Math.abs(diff3) > 0.05) {
      this.currentCurve3 += diff3 * 0.1;
      this.updatePath(this.currentCurve3, this.path3);
    }

    // Curve 4
    const diff4 = this.targetCurve4 - this.currentCurve4;
    if (Math.abs(diff4) > 0.05) {
      this.currentCurve4 += diff4 * 0.1;
      this.updatePath(this.currentCurve4, this.path4);
    }
  }

  updatePath(curveAmount, pathElement) {
    if (!pathElement) return;

    const W = 1440;
    let H = 400; // SVGのviewBox高さ

    if (pathElement === this.path1) {
      H = 500;
    } else if (pathElement === this.path4) {
      H = 300;
    }

    const y = this.BASE_Y;

    let cpY;
    let d;

    if (pathElement === this.path2) {
      // #curve-svg2: 上側を塗りつぶす（Section 1の茶色を延長）
      // カーブ方向: 下に凸（谷なり）センターをy軸的に大きく、左右は相対的に上
      // 変形が最大に近づくほど、左右の端点も最大20px上に移動する
      const endpointY = y - 20 * (curveAmount / this.MAX_CURVE);
      // センターは通常のカーブ量に加え、最大変形時にさらに50px下に沈む
      cpY = endpointY + curveAmount + 50 * (curveAmount / this.MAX_CURVE);
      d = `M 0 0 L ${W} 0 L ${W} ${endpointY} Q ${W / 2} ${cpY} 0 ${endpointY} Z`;
    } else if (pathElement === this.path4) {
      // #curve-svg4: section2の背景色(#F6EDE4)を上に延長する山なりカーブ
      // カーブ方向: 上に凸（山なり）センターをy軸的に小さく、curve2と逆向きに連動
      cpY = y - curveAmount;
      // 下側（section2側）を塗りつぶす
      d = `M 0 ${H} L ${W} ${H} L ${W} ${y} Q ${W / 2} ${cpY} 0 ${y} Z`;
    } else if (pathElement === this.path3) {
      // #curve-svg3: chunk6上端付近~chunk8を覆う背景。波線は要素の最上部(y=0)に描く
      // 要素の高さが可変なため、viewBoxの伸縮率を打ち消してカーブ量が見た目のpx通りになるよう変換する
      const k = this.svg3HeightPx > 0 ? H / this.svg3HeightPx : 1; // px -> viewBox座標の係数
      cpY = curveAmount * k;
      // 下側を塗りつぶす
      d = `M 0 ${H} L ${W} ${H} L ${W} 0 Q ${W / 2} ${cpY} 0 0 Z`;
    } else {
      // #curve-svg1 は下に凸（谷なり）
      cpY = y + curveAmount;
      // 下側を塗りつぶす
      d = `M 0 ${H} L ${W} ${H} L ${W} ${y} Q ${W / 2} ${cpY} 0 ${y} Z`;
    }

    pathElement.setAttribute('d', d);
  }

  easeOutQuart(t) {
    return 1 - Math.pow(1 - t, 4);
  }

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
    this.isSp = this.sw < this.pack.BP;
    this.updateCurve3Bounds();
  }

  // #curve-svg3 を .chunk6 の上端の少し下(=波線の位置) ~ .chunk8 の上端まで敷く背景レイヤーとして配置する
  // 波線は要素の最上部に描くので、要素のtop = 波線の位置になる
  updateCurve3Bounds() {
    if (!this.svg3 || !this.section4 || !this.chunk6 || !this.chunk8) return;

    const section4Rect = this.section4.getBoundingClientRect();
    const chunk6Rect = this.chunk6.getBoundingClientRect();
    const chunk8Rect = this.chunk8.getBoundingClientRect();

    const OVERLAP = 2; // chunk8との間の隙間対策
    const topOffset = this.isSp ? this.CURVE3_TOP_OFFSET_SP : this.CURVE3_TOP_OFFSET_PC;
    const top = chunk6Rect.top - section4Rect.top + topOffset;
    const height = Math.max(0, chunk8Rect.top - chunk6Rect.top - topOffset + OVERLAP);

    // レイアウトに変化があった時だけstyleを書き換える
    if (Math.abs(top - this.svg3Top) > 0.5 || Math.abs(height - this.svg3HeightPx) > 0.5) {
      this.svg3Top = top;
      this.svg3HeightPx = height;
      this.svg3.style.top = `${top}px`;
      this.svg3.style.height = `${height}px`;
      // 高さが変わるとviewBoxの伸縮率も変わるのでパスを描き直す
      this.updatePath(this.currentCurve3, this.path3);
    }
  }

  animateToFlat() {
    this.isAnimatingFlat = true;
    
    // 初期状態：最大カーブにセットして即描画
    this.currentCurve = this.MAX_CURVE;
    this.updatePath(this.currentCurve, this.path1);

    // 1.5秒かけてゆったりと直線(0)に戻す
    this.flatTween = gsap.to(this, {
      currentCurve: 0,
      duration: 1.5,
      ease: 'power2.out',
      onUpdate: () => this.updatePath(this.currentCurve, this.path1),
      onComplete: () => {
        this.isAnimatingFlat = false; // アニメーション終了後に慣性処理に戻す
        this.flatTween = null;
        this.targetCurve = 0;
      }
    });
  }
}
